<template>
	<div class="grid-flex-container">
		<v-container fluid class="px-0">
			<v-text-field
				v-model="search"
				class="py-0 my-0 mb-2"
				append-icon="mdi-magnify"
				label="Search"
				single-line
				hide-details
				v-debounce:500ms="onSearchChanged"
			></v-text-field
		></v-container>
		<div class="generic-grid-container">
			<v-data-table
				:headers="headers"
				:items="items"
				:search="search"
				:disable-pagination="false"
				:footer-props="{
					itemsPerPageOptions: [10, 15, 20, 25, 30, 50, 100],
					showFirstLastPage: true,
					showCurrentPage: true,
					pagination: {
						page,
						itemsPerPage: rowsPerPage,
						pageStart,
						pageStop,
						pageCount,
						itemsLength: totalCount,
					},
				}"
				:options.sync="options"
				:server-items-length="totalCount"
				fixed-header
				dense
				:loading="loading"
				loading-text="Loading..."
			>
				<template v-slot:[`item.FirstName`]="{ item }"
					><span>{{
						item.FirstName + ' ' + item.LastName
					}}</span></template
				>
				<template v-slot:[`item.FileUploadDate`]="{ item }"
					><span>{{
						new Date(item.FileUploadDate).toLocaleString()
					}}</span></template
				>
				<template v-slot:[`item.ImportStartDate`]="{ item }"
					><span>{{
						new Date(item.ImportStartDate).toLocaleString()
					}}</span></template
				>
				<template v-slot:[`item.ImportEndDate`]="{ item }"
					><span>{{
						new Date(item.ImportEndDate).toLocaleString()
					}}</span></template
				>
				<template v-slot:[`item.Status`]="{ item }">
					{{ getImportStatus(item) }}
				</template>
			</v-data-table>
		</div>
	</div>
</template>

<script>
import { importStatus } from '../../../enums/importStatus';
import { DataImportGetters } from '../../../store/getters';
import { DataImportActions } from '../../../store/actions';
import { mapGetters } from 'vuex';
export default {
	name: 'DataImportFilesGrid',
	data() {
		return {
			timer: null,
			page: 1,
			rowsPerPage: 10,
			search: '',
			headers: [
				{ text: 'File Name', sortable: true, value: 'FileName' },
				{
					text: 'Upload Date',
					sortable: true,
					value: 'FileUploadDate',
				},
				{
					text: 'Import Start Date',
					sortable: true,
					value: 'ImportStartDate',
				},
				{
					text: 'Import End Date',
					sortable: true,
					value: 'ImportEndDate',
				},
				{ text: 'Imported By', sortable: true, value: 'FirstName' },
				{ text: 'Template', sortable: true, value: 'TemplateName' },
				{ text: 'Status', sortable: true, value: 'Status' },
				{ text: 'Summary', sortable: false, value: 'Summary' },
			],
		};
	},
	computed: {
		...mapGetters({
			items: [DataImportGetters.GET_FILES],
			totalCount: [DataImportGetters.TOTAL_COUNT],
			loading: [DataImportGetters.GRID_LOADING],
		}),

		pageStart() {
			return this.rowsPerPage * (this.page - 1);
		},
		pageStop() {
			return this.rowsPerPage * this.page;
		},
		pageCount() {
			if (!this.rowsPerPage) return 0;
			if (!this.totalCount) return 0;
			let quotient = Math.floor(this.totalCount / this.rowsPerPage);
			let remainder = this.totalCount % this.rowsPerPage;
			if (remainder === 0) return quotient;
			return quotient + 1;
		},

		options: {
			get() {
				return {
					page: this.page,
					itemsPerPage: this.rowsPerPage,
				};
			},
			set(data) {
				if (this.page != data.page && !isNaN(data.page)) {
					this.page = data.page;
					this.loadData();
				}

				if (
					this.rowsPerPage != data.itemsPerPage &&
					!isNaN(data.itemsPerPage)
				) {
					this.rowsPerPage = data.itemsPerPage;
					this.loadData();
				}
			},
		},
	},
	mounted() {
		this.loadData();
		this.timer = setInterval(() => {
			this.refreshData();
		}, 15000);
	},
	beforeDestroy() {
		clearInterval(this.timer);
		this.timer = null;
	},
	methods: {
		loadData() {
			this.$store.dispatch(DataImportActions.LOAD_FILES, {
				page: this.page,
				rowsPerPage: this.rowsPerPage,
				filter: this.search,
			});
		},

		refreshData() {
			let canRefresh = this.items.filter(
				(x) => x.Status < importStatus.Completed
			);
			if (canRefresh.length <= 0) return;
			this.loadData();
		},
		onSearchChanged() {
			this.loadData();
		},

		getImportStatus(item) {
			switch (item.Status) {
				case importStatus.None:
					return 'None';
				case importStatus.FileUploaded:
					return 'File Uploaded';
				case importStatus.InProgress:
					return 'In Progress';
				case importStatus.Completed:
					return 'Completed';
				case importStatus.ErrorProcessingFile:
					return 'Error Processing File';
				default:
					return 'Text';
			}
		},
	},
};
</script>
